import { render } from "./tableSize.vue?vue&type=template&id=a68588d4&scoped=true"
const script = {}

import "./tableSize.vue?vue&type=style&index=0&id=a68588d4&lang=scss&scoped=true"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a68588d4"]])

export default __exports__